import { render } from "./GraficoEmprestimoCircular.vue?vue&type=template&id=d070d2e8"
import script from "./GraficoEmprestimoCircular.vue?vue&type=script&lang=js"
export * from "./GraficoEmprestimoCircular.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__